document.addEventListener('DOMContentLoaded', function () {
    function customPhoneMessage() {
        function updatePhoneMessage() {
            const now = new Date();
            const options = { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', weekday: 'short' };
            const formatter = new Intl.DateTimeFormat('en-GB', options);
            const parts = formatter.formatToParts(now);

            let day, hours, minutes;
            for (const part of parts) {
                if (part.type === 'weekday') day = part.value;
                if (part.type === 'hour') hours = parseInt(part.value, 10);
                if (part.type === 'minute') minutes = parseInt(part.value, 10);
            }

            const phoneMessages = document.querySelectorAll('.dynamic-phone-message');
            phoneMessages.forEach(function(phoneMessage) {
                const hoursLabel = phoneMessage.querySelector('.c-header-call-cta__hours-label');
                const hoursTime = phoneMessage.querySelector('.c-header-call-cta__hours-time');
                const hoursLabel2 = phoneMessage.querySelector('.c-header-call-cta__hours-label-2');

                // Define a function to parse time strings like "8am" or "8pm" to minutes
                function parseTime(timeStr) {
                    const [time, period] = timeStr.split(/(am|pm)/);
                    let [hour, minute] = time.split(':').map(Number);
                    if (isNaN(minute)) minute = 0;
                    if (period === 'pm' && hour !== 12) hour += 12;
                    if (period === 'am' && hour === 12) hour = 0;
                    return hour * 60 + minute;
                }

                // Define opening hours using the settings
                const openingHours = {
                    Mon: openHoursSettings.phone_open_monday.split('-').map(parseTime),
                    Tue: openHoursSettings.phone_open_tuesday.split('-').map(parseTime),
                    Wed: openHoursSettings.phone_open_wednesday.split('-').map(parseTime),
                    Thu: openHoursSettings.phone_open_thursday.split('-').map(parseTime),
                    Fri: openHoursSettings.phone_open_friday.split('-').map(parseTime),
                    Sat: openHoursSettings.phone_open_saturday.split('-').map(parseTime),
                    Sun: openHoursSettings.phone_open_sunday.split('-').map(parseTime)
                };

                const currentTime = hours * 60 + minutes;
                const todayHours = openingHours[day.slice(0, 3)];

                if (currentTime >= todayHours[0] && currentTime < todayHours[1]) {
                    hoursLabel.textContent = 'Phone lines open until ';
                    hoursTime.textContent = formatTime(todayHours[1]);
                    hoursLabel2.textContent = 'today!';
                } else {
                    let nextOpenTime, nextOpenDay;

                    if (currentTime >= todayHours[1]) {
                        // Determine the next opening time and day
                        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                        const currentIndex = days.indexOf(day.slice(0, 3));
                        let nextIndex = (currentIndex + 1) % 7;
                        nextOpenDay = days[nextIndex];
                        nextOpenTime = openingHours[nextOpenDay][0];
                    } else {
                        nextOpenDay = day.slice(0, 3);
                        nextOpenTime = todayHours[0];
                    }

                    if (currentTime >= todayHours[1]) {
                        hoursLabel.textContent = 'Phones closed. Opens at ';
                        hoursTime.textContent = formatTime(nextOpenTime);
                        hoursLabel2.textContent = 'tomorrow!';
                    } else {
                        hoursLabel.textContent = 'Phone lines opens at ';
                        hoursTime.textContent = formatTime(nextOpenTime);
                        hoursLabel2.textContent = 'today!';
                    }
                }
            });
        }

        // Helper function to format minutes into "8am" or "10am" etc.
        function formatTime(minutes) {
            let hour = Math.floor(minutes / 60);
            const minute = minutes % 60;
            const period = hour >= 12 ? 'pm' : 'am';
            if (hour > 12) hour -= 12;
            if (hour === 0) hour = 12;
            return minute === 0 ? `${hour}${period}` : `${hour}:${minute.toString().padStart(2, '0')}${period}`;
        }

        // Initial call
        updatePhoneMessage();

        // Update every minute
        setInterval(updatePhoneMessage, 60000);
    }

    customPhoneMessage();
});